import PrimaryButton from '../components/PrimaryButton';
import TextButton from '../components/TextButton/TextButton';
import styles from './DetailsButton.module.scss';

interface DetailsButtonProps {
  type: string;
  description: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isArchivedClassroom?: boolean;
}

const DetailsButton = ({ type, description, onClick, isArchivedClassroom }: DetailsButtonProps): JSX.Element => {
  if (type === 'submit') {
    return (
      <PrimaryButton type='submit' className={styles.submitButton} small>
        {description}
      </PrimaryButton>
    );
  } else {
    if (description === 'Archive Classroom') {
      if (!isArchivedClassroom) {
        return (
          <TextButton bold inline grey uppercase underlineHover type={type} onClick={onClick}>
            {description}
          </TextButton>
        );
      } else {
        return <div style={{ display: 'none' }}></div>;
      }
    } else if (description === 'Delete Classroom') {
      return (
        <TextButton bold inline red uppercase underlineHover type={type} onClick={onClick}>
          {description}
        </TextButton>
      );
    } else {
      return <div style={{ display: 'none' }}></div>;
    }
  }
};

export default DetailsButton;
